var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('layout-header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('global-layout',{ref:"global"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }